export const a11yProps = (index) => ({
  id: `simple-tab-${index}`,
  'aria-controls': `simple-tabpanel-${index}`,
});

export const normalizePhoneNumber = (phoneNumber) => {
  let p = (phoneNumber && phoneNumber !== 'N/A')
    ? phoneNumber?.split('/')[0]
    : '';

  if (p) {
    p = p.trim();
    p = p.replace(/[-)(\s\\+]/g, '');
    p = (p.length <= 10) ? `+1${p}` : `+${p}`;
  }

  return p;
};

export const copyToClipboard = (element) => {
  element.select();
  document.execCommand('copy');
};

export const toBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();

  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = (error) => reject(error);
});

export const isMobile = () => (
  navigator.userAgent.match(/Android/i)
  || navigator.userAgent.match(/webOS/i)
  || navigator.userAgent.match(/iPhone/i)
  || navigator.userAgent.match(/iPad/i)
  || navigator.userAgent.match(/iPod/i)
  || navigator.userAgent.match(/BlackBerry/i)
  || navigator.userAgent.match(/Windows Phone/i)
);

export const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

export default {
  a11yProps,
  normalizePhoneNumber,
  toBase64,
  isMobile,
};
